import { AriApiQueryCreatorFetch } from './AriApiCreator';
import { prismScopes } from './auth';


/**
 * Minimal RTK Query API service backed by AriApiQueryCreatorFetch, targeting the map API endpoint and using Prism scopes with the API Manager URL.
 *
 * Currently exposes only a single dummy getSomething query; intended to be expanded with map-specific endpoints.
 */
export const MapService = AriApiQueryCreatorFetch({
  apiOptions: {
    reducerPath: 'mapApi',
    endpoints: (build) => ({
      getSomething: build.query<any, string[]>({
        query: () => ({
          url: `/Function1`,
          method: 'GET'
        })
      })
    })
  },
  scopesObj: prismScopes,
  // @ts-ignore
  serviceURL: import.meta.env.VITE_API_MGR_URL
});

export const { useGetSomethingQuery } = MapService.hooks;
export const { useApiGetRolesHook: useMapServiceRoles } = MapService;


